// src/App.js

import React from 'react';
import { Routes, Route } from 'react-router-dom';

// İki alt modül
import VatandasApp from './vatandas/VatandasApp';
import BelediyeApp from './belediye/BelediyeApp';

function App() {
  return (
    <Routes>
      {/* Belediye rotaları => /yonetim/* */}
      <Route path="/yonetim/*" element={<BelediyeApp />} />

      {/* Vatandaş rotaları => diğer her şey */}
      <Route path="/*" element={<VatandasApp />} />
    </Routes>
  );
}

export default App;
